import { render, staticRenderFns } from "./pageTitle.vue?vue&type=template&id=4be1a28c&scoped=true&"
import script from "./pageTitle.vue?vue&type=script&lang=js&"
export * from "./pageTitle.vue?vue&type=script&lang=js&"
import style0 from "./pageTitle.vue?vue&type=style&index=0&id=4be1a28c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4be1a28c",
  null
  
)

export default component.exports